// src/pages/admin/CourseEdit.js
import React, { useEffect } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';

const CourseEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  // Simulated API call to fetch course data
  useEffect(() => {
    const fetchCourse = async () => {
      try {
        // Replace with your actual API call (e.g., axios.get(`/api/courses/${id}`))
        const mockCourse = {
          name: 'Introduction to JavaScript',
          description: 'Learn JS basics',
          status: 'Active',
        };
        form.setFieldsValue(mockCourse); // Pre-fill form with course data
      } catch (error) {
        message.error('Failed to load course');
        console.error(error);
      }
    };
    fetchCourse();
  }, [id, form]);

  const onFinish = async (values) => {
    try {
      // Replace with your actual API call (e.g., axios.put(`/api/courses/${id}`, values))
      console.log('Updating course:', { id, ...values }); // Simulated API call
      message.success('Course updated successfully');
      navigate('/admin/courses-manage');
    } catch (error) {
      message.error('Failed to update course');
      console.error(error);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h1>Edit Course</h1>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter the course name' }]}
        >
          <Input placeholder="Enter course name" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: 'Please enter a description' }]}
        >
          <Input.TextArea placeholder="Enter course description" rows={4} />
        </Form.Item>
        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: 'Please enter the status' }]}
        >
          <Input placeholder="e.g., Active or Draft" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Update Course
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate('/admin/courses-manage')}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CourseEdit;